<template>
  <div class="select-input" :class="{ hasError: errorMessages.length > 0 }">
    <v-select
      v-model="modelValue"
      v-bind="$attrs"
      v-validate="validations"
      :error="errorMessages.length > 0"
      :hide-details="true"
      :data-vv-as="displayName"
      :data-vv-name="inputIdentifier"
      :id="`select_${inputIdentifier}`"
      :items="items"
      :name="inputIdentifier"
      :menu-props="{ auto: true }"
      :label="displayName"
      flat
      box
      ref="select-input-common"/>
  </div>
</template>

<script>
const nonCharacterRegex = /([^a-z0-9])/g;
const duplicatedHyphensRegex = /-+/g;
const startEndHyphensRegex = /(^-)|(-$)/g;
const capitalCharacterRegex = /([A-Z])/g;

export default {
  inject: ['$validator'],
  props: {
    displayName: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    validations: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    errorMessages() {
      return (this.errors && this.errors.collect)
        ? this.errors.collect(this.inputIdentifier)
        : [];
    },
    inputIdentifier() {
      if (this.identifier) {
        return this.identifier;
      }

      return this.displayName
        .replace(capitalCharacterRegex, '-$1')
        .toLowerCase()
        .replace(nonCharacterRegex, '-')
        .replace(duplicatedHyphensRegex, '-')
        .replace(startEndHyphensRegex, '');
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

.v-input--is-focused {
  box-shadow: 0 0 1px  $theme-color-primary;
  border-bottom: 1px solid $theme-color-primary;
}

::v-deep .v-text-field__details {
  display: none;
}

::v-deep input {
  border: none;
  color: rgba(0, 0, 0, 0.7);
  font-size: 1rem;
  padding: 10px 15px;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
}

.hasError {
  label {
    color: $theme-color-alert;
  }

  .v-input {
    border-bottom: 1px solid rgba($theme-color-alert, 0.5);
  }

  ::v-deep input {
    color: $theme-color-alert;
  }
}
</style>
